module.exports = __webpack_public_path__ + "images/sp/common/bg_item_watch_recommendation_0d035670ce6eef7aa4ef95d4938115cc.png";